module.exports = __webpack_public_path__ + "img/symbol_3.260e3211.png";